import { createAsyncThunk } from '@reduxjs/toolkit';
import { noticeError } from '@travel/tracker';

import { apiPath } from 'constants/api';

export const setViewCount = createAsyncThunk<any, any, { extra: { apiClient: any } }>(
  'viewCount/post',
  async (payload, { extra: { apiClient }, rejectWithValue }) => {
    try {
      const data = await apiClient.patch(apiPath.setViewCount.pathname, {
        ignoreCommonErrorHandler: true,
        headers: {
          'Content-Type': 'application/json',
        },
        values: payload,
      });

      return data;
    } catch (error) {
      noticeError('Add Viewcount Failed', error);

      return rejectWithValue(error.message);
    }
  },
);
